<template>
  <div>
    <div
      v-for="(templatePerm, templateIndex) in contentValue"
      :key="`special-with-template-perm-${templateIndex}`"
      class="special-with-building-list"
    >
      <div class="list-title title-with-building small-4">
        <div class="list-title-label small-6">
          {{ templateIndex === 0 ? index : '' }}
        </div>
        <HKLSelect
          v-if="isEdit"
          :value="templatePerm.template || ''"
          class="wp-template-selection"
          :options="filteredTemplates(templateIndex)"
          @change="($event) => handleTemplateChange(templateIndex, $event)"
        />
        <div v-else>
          {{ templatePerm.template ? $t(`emailTemplate.${templateModule}.${templatePerm.template}`) : '' }}
        </div>
      </div>
      <HKLMultiSelect
        v-if="isEdit"
        :key="`entitlement-select-${templateIndex}`"
        class="small-7"
        :options="entitlements"
        :value="getEntitlementSelections(templatePerm)"
        @change="($event) => handleEntitlementChange(templateIndex, $event)"
      />
      <div
        v-if="isEdit"
        class="small-1"
      >
        <div
          v-if="contentValue.length"
          class="remove-btn"
          @click="() => onDelete(templateIndex)"
        >
          <i class="fa fa-times fa-lg" />
        </div>
      </div>
      <p
        v-if="!isEdit"
        class="content-value"
      >
        {{ formatPermStr(templatePerm) }}
      </p>
    </div>
    <div class="row">
      <div class="list-title title-with-building small-4" />
      <HKLButton
        v-if="isEdit"
        class="add-btn"
        action="addPlus"
        @click="() => onAdd()"
      />
    </div>
  </div>
</template>

<script>

import { toRefs } from 'vue-demi'
import HKLSelect from '@/controls/Select/HKLSelect.vue'
import HKLMultiSelect from '@/controls/Select/HKLMultiSelect.vue'
import HKLButton from '@/controls/Button/HKLButton.vue'
export default {
  name: 'TemplateEntitlementList',
  components: { HKLSelect, HKLMultiSelect, HKLButton },
  props: {
    isEdit: {
      type: Boolean,
      default: false,
    },
    contentValue: {
      type: Array,
      default: () => [], // Default value as an empty array
    },
    index: {
      type: String,
      default: '',
    },
    templateModule: {
      type: String,
      default: '',
    },
    templates: {
      type: Array,
      default: () => [],
    },
    entitlements: {
      type: Array,
      default: () => [],
    },
    getEntitlementSelections: {
      type: Function,
      default: () => {},
    },
    formatPermStr: {
      type: Function,
      default: () => {},
    },
    onDelete: {
      type: Function,
      default: () => {},
    },
    onAdd: {
      type: Function,
      default: () => {},
    },
  },
  setup (props, { emit }) {
    const {
      contentValue,
      templates,
    } = toRefs(props)

    const filteredTemplates = (templateIndex) => {
      const selectedKeys = contentValue.value
        .filter((item, idx) => idx !== templateIndex)
        .map((item) => item.template)
      return templates.value.filter((t) => !selectedKeys.includes(t.value))
    }

    const handleTemplateChange = (templateIndex, newTemplate) => {
      const updated = contentValue.value.map((item, idx) =>
        idx === templateIndex
          ? { ...item, template: newTemplate }
          : item,
      )
      emit('update:contentValue', updated)
    }

    const handleEntitlementChange = (templateIndex, newPermList) => {
      const updated = contentValue.value.map((item, idx) =>
        idx === templateIndex
          ? { ...item, permList: Array.isArray(newPermList) ? newPermList : [] }
          : item,
      )
      emit('update:contentValue', updated)
    }

    return {
      filteredTemplates,
      handleTemplateChange,
      handleEntitlementChange,
    }
  },
}
</script>

<style lang="scss" scoped>
.special-with-building-list {
  display: flex;
  margin-top: 10px;
  margin-right: 10px;
}
.list-title {
  margin-right: 10px;
  word-break: break-word;
}
.title-with-building {
  display: flex;
}
.content-value {
  word-break: break-word;
}
.add-btn {
  text-align: left;
  text-decoration: underline;
  font-style: italic;
  cursor: pointer;
  margin-left: 10px;
}
.remove-btn {
  cursor: pointer;
  font-size: 14px;
  margin-left: 10px;
  margin-top: 8px;
}
.list-title-label {
  margin-right: 10px;
}
.wp-template-selection {
  max-height: 42px;
}
</style>
